fragment settingsFields on Workspace {
  settings {
    backgroundColor
    foregroundColor
    logoUrl
  }
}
